import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import BottomTabNavigation from '../../components/ui/BottomTabNavigation'
import Button from '../../components/ui/Button'
import Input from '../../components/ui/Input'
import { useAuth } from '../../contexts/AuthContext'

const UserProfile = () => {
  const navigate = useNavigate()
  const { user, updateProfile, signOut } = useAuth()
  const [username, setUsername] = useState(user?.username || '')
  const [bio, setBio] = useState(user?.bio || '')
  const [avatarUrl, setAvatarUrl] = useState(user?.avatarUrl || '')
  const [message, setMessage] = useState('')

  if (!user) {
    navigate('/login')
    return null
  }

  const handleSave = async (event) => {
    event.preventDefault()
    await updateProfile({ username, bio, avatarUrl })
    setMessage('Profile updated')
  }

  return (
    <div className="min-h-screen bg-background pb-20">
      <main className="max-w-xl mx-auto px-4 py-8 space-y-4">
        <h1 className="text-2xl font-semibold">Your profile</h1>
        <p className="text-muted-foreground">Signed in as {user.email}</p>

        <form onSubmit={handleSave} className="space-y-4">
          <Input label="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
          <Input label="Avatar URL" value={avatarUrl} onChange={(e) => setAvatarUrl(e.target.value)} />
          <label className="block">
            <span className="block mb-2">Bio</span>
            <textarea value={bio} onChange={(e) => setBio(e.target.value)} className="w-full min-h-24 rounded-lg border border-border bg-card p-3" />
          </label>
          <div className="flex gap-3">
            <Button type="submit">Save</Button>
            <Button type="button" variant="outline" onClick={() => { signOut(); navigate('/login') }}>Sign out</Button>
          </div>
          {message && <p className="text-sm text-success">{message}</p>}
        </form>
      </main>
      <BottomTabNavigation activeTab="profile" />
    </div>
  )
}

export default UserProfile
